export const DEFAULT_COLUMNS = [
  {
    key: "voter_id",
    text: "Voter ID",
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "first_name",
    text: "First Name",
    canEdit: true,
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "middle_name",
    text: "Middle Name",
    canEdit: true,
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "last_name",
    text: "Last Name",
    canEdit: true,
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "phone_number",
    text: "Phone Number",
    isActive: true,
    canEdit: true,
    isDisabled: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "user_email",
    text: "Email",
    isActive: true,
    canEdit: true,
    isDisabled: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "voted",
    text: "Harris County Voted",
    isActive: true,
    tooltip: 'Check harrisvotes.com to see if you have a ballot for your area',
    filter: { type: "dropdown", value: "", values: ["Voted", "Not Voted"] },
  },
  // {
  //   key: "last_activity_at",
  //   text: "Last Contacted At",
  //   canEdit: false,
  //   isActive: true,
  //   filter: { type: "dropdown", value: "", values: ["Today", "Yesterday","This Week", "Last 7 Days","Last Week","This Month","Last Month","Last 90 Days","This Year"] },
  // },
  // {
  //   key: "update_last_contacted",
  //   text: "Contact Now",
  //   canEdit: false,
  //   isActive: true,
  //   filter: { type: "search", value: "" },
  // },
  // {
  //   key: "g_score",
  //   text: "G Score",
  //   isActive: true,
  //   isDisabled: true,
  //   tooltip:
  //     "Measures the likelihood of a voter participating in general elections. A higher score indicates a more reliable voter.",
  //   filter: { type: "search", value: "" },
  // },
  // {
  //   key: "r_score",
  //   text: "R Score",
  //   isActive: true,
  //   isDisabled: true,
  //   tooltip:
  //     "Measures the likelihood of a voter supporting Republican candidates. A higher score indicates stronger Republican support.",
  //   filter: { type: "search", value: "" },
  // },
  // {
  //   key: "rank",
  //   text: "Rank",
  //   isActive: true,
  //   isDisabled: true,
  //   filter: { type: "search", value: "" },
  // },
  {
    key: "general_voting_history",
    text: "General Voting History",
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "primary_voting_history",
    text: "Primary Voting History",
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "school_district",
    text: "School District",
    canEdit: true,
    isActive: false,
    tooltip:
      "Use this filter to view all SBISD voters from your list.",
    filter: { type: "dropdown", value: "", values: [] },
  },
  {
    key: "sbisd_voted",
    text: "SBISD Voted",
    canEdit: false,
    isActive: false,
    tooltip:
      "SBISD runs its own elections.",
    filter: { type: "dropdown", value: "", values: ["Voted", "Not Voted"] },
  },
];

console.log(DEFAULT_COLUMNS,"Dddd");


export const DEFAULT_SORT = [];
export const DEFAULT_PER_PAGE = 100;

const memory = JSON.parse(localStorage.getItem("my-list-memory"));

const listNames = JSON.parse(localStorage.getItem("listNames"));

const data = JSON.parse(localStorage.getItem("my-list-data"));

const activeListName = listNames
  ? memory?.activeListName || listNames[0]
  : undefined;

export default {
  data: data
    ? data.data.filter((voter) => voter.list_name === activeListName)
    : [],
  totalPages: data ? data.totalPages : 0,
  page: 1,
  perPage: memory?.perPage || DEFAULT_PER_PAGE,
  sort: memory?.sort || DEFAULT_SORT,
  columns: memory?.columns || DEFAULT_COLUMNS,
  selectedRows: [],
  fetchedVoters: null,
  fetchedFor: null,
  searchedVoters: null,
  listNames: listNames || [],
  activeListName,
  status: {
    fetchData: "",
    actions: "idle",
    export: "idle",
    upload: "idle",
    search: "idle",
    addOneVoter: "idle",
    edit: "idle",
    deleteData: "idle",
    addList: "idle",
    renameList: "idle",
    removeList: "idle",
    moveVoter: "idle",
    uploadStats: {
      added: 0,
      updated: 0,
      skipped: 0
    }
  },
};
